import { useContext } from 'react'
import { Input } from 'antd'
import styles from './list.module.scss'
import { FilteredComplaintsContext } from '@BUP/contexts/filtered-complaints-context'
import { SearchOutlined } from '@ant-design/icons'

export const SearchComplaintList = ({ placeholder }) => {
  const {
    setSearchTitle
  } = useContext(FilteredComplaintsContext)

  return (
    <Input
      placeholder={placeholder}
      allowClear
      onChange={e => setSearchTitle(e.target.value)}
      className={styles.search_input}
      prefix={<SearchOutlined style={{ color: '#898a89' }} />}

    />
  )
}
